import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "Dkarez Community Support CIC — Where compassion becomes change",
  description:
    "Spes alit, vitam renovat — Hope nourishes, life renews. A trusted, verified crowdfunding platform connecting donors with people in genuine need.",
  image:
    "/logo.jpg",
};

export default function Seo({ title, description, image, url, type = "website" }) {
  const t = title ? `${title} · Dkarez` : DEFAULTS.title;
  const d = (description || DEFAULTS.description).slice(0, 300);
  const i = image || DEFAULTS.image;
  const u = url || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d} />
      {u && <link rel="canonical" href={u} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Dkarez Community Support CIC" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={i} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {u ? <meta property="og:url" content={u} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={i} />
    </Helmet>
  );
}
